import md5 from 'md5';
import {sha256} from 'js-sha256';

import Customer from 'coreClasses/customer/Customer';
import ManagerRepository from 'coreClasses/ManagerRepository';
import CookiesMgr from 'coreClasses/cookies/CookiesMgr';

/**
 * Represents UserInfoModel
 */
export default class UserInfoModel {
	public country: string;
	public language: string;
	public loggedIn: string;
	public visitorStatus: string;
	public userID: string;
	public newsletterSubscription: boolean;
	public gender?: string;
	public _email?: string;
	public firstName?: string;
	public lastName?: string;
	public customerID?: string;
	public accountCustomerId?: string;
	public customer_type?: string;
	public crmID?: string
	public personalShopperId?: string;
	public returningCustomer?: boolean;
	public email_hash?: string;
	public phone_hash?: string;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - customer
	 * @param {Customer} customer - customer
	 */
	constructor(managerRepository: ManagerRepository, customer: Customer) {
		const currentLocale = managerRepository.getLocalesMgr().getCurrentLocale();
		const customerNumberAsUserID = managerRepository
			.getConfigurationsMgr()
			.get('sitePreferences.dataLayerIsUseCustomerNoAsUserID');
		const userID = customerNumberAsUserID ? customer.customerNo : customer.customerId;

		this.country = currentLocale.getCountryCode();
		this.language = currentLocale.getLanguageCode();

		this.loggedIn = customer.isRegistered ? 'Logged In' : 'Not Logged In';
		this.visitorStatus = customer.isRegistered ? 'regular logged' : 'not logged';

		this.userID = customer.isRegistered ? userID : '';
		this.newsletterSubscription = customer.isSubscribedToNewsletter();
		this.personalShopperId = CookiesMgr.getCookie('personalShopperUserId').getValue() || '';

		if (customer.isRegistered) {
			if (customer.gender) {
				this.gender = customer.gender === 2 ? 'woman' : 'men';
			}

			this._email = customer.email;
			this.firstName = customer.firstName;
			this.lastName = customer.lastName;
			this.customerID = md5(customer.email, {encoding: 'hex'}).toString();
			this.accountCustomerId = customer.customerNo;
			this.customer_type = customer.isHasOrders() ? 'existing' : 'new';
			this.crmID = customer.getCustomerCrmId();
			this.returningCustomer = customer.isHasOrders();
			this.email_hash = sha256(customer.email);

			if (customer.phoneCode && customer.phone) {
				this.phone_hash = sha256(customer.phoneCode.trim() + customer.phone.trim());
			}
		}
	}
};
